import React from "react";

const Contact = () => {
  const handleResumeDownload = () => {
    const link = document.createElement("a");
    link.href = "/Farha_Lina_Resume.pdf";
    link.download = "Farha_Lina_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="contact">
      <div className="contact-inner fade-up">
        <p className="section-eyebrow" style={{ justifyContent: "center" }}>Get in touch</p>
        <h2 className="contact-title">Let's work together</h2>
        <p className="contact-subtitle">
          I'm currently open to new opportunities. Whether you have a role in mind,
          a project to collaborate on, or just want to say hello — I'd love to hear from you.
        </p>
        <div className="contact-links">
          <a href="mailto:farhalin@gmail.com" className="contact-link primary">
            ✉ farhalin@gmail.com
          </a>
          <a
            href="https://www.linkedin.com/in/farhalina/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link secondary"
          >
            LinkedIn →
          </a>
          <button
            onClick={handleResumeDownload}
            className="contact-link secondary"
            style={{ border: "1.5px solid var(--green-pale)", cursor: "pointer", fontFamily: "inherit" }}
          >
            ↓ Resume
          </button>
        </div>
      </div>
    </section>
  );
};

export default Contact;
